import Header from "../../components/Header/Header";

export const InterviewsPage = () => {
  return (
    <>
      <Header />
      <main style={{ maxWidth: 1240, margin: "0 auto", padding: "48px 24px" }}>
        <div
          style={{
            border: "1px solid rgba(77, 163, 255, 0.16)",
            borderRadius: 28,
            background: "rgba(255, 255, 255, 0.04)",
            boxShadow: "0 18px 40px rgba(2, 6, 23, 0.14)",
            backdropFilter: "blur(16px)",
            padding: 32,
          }}
        >
          <p style={{ margin: "0 0 12px", color: "#4da3ff", textTransform: "uppercase", letterSpacing: "0.12em" }}>
            СОБЕСЫ
          </p>
          <h1 style={{ margin: "0 0 16px", fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>Подготовка к собеседованиям</h1>
          <p style={{ margin: 0, maxWidth: 700, color: "var(--text-muted)", lineHeight: 1.7 }}>
            Здесь будет отдельный раздел Neuro Boost для тренировок, быстрых ответов и сценариев интервью.
          </p>
        </div>
      </main>
    </>
  );
};
